
<div class="dashboard-tile dialog" class="flush" style="height: 90vh;">
  <div class="tile-content dialog-content">
    <div style="display: flex; flex-direction:column">
      <div style="display: flex; align-items: center;" [ngStyle]="themeManager.getUnderlayStyle(false)">
        <div style="max-width: 400px; padding: 50px; color: white;">
          <img class="logo" src="{{themeManager.getWhiteLogo()}}">
          <h2 >Welcome to Identify</h2>
          <h4>ConnectWise Identify helps you discover critical security risks and outline a plan to remediate them. Before you start assessing your customers, identify your own risks.</h4>
          <h4><button mat-raised-button (click)="openUrl('https://docs.connectwise.com/ConnectWise_Identify/002/040');">Assess Your Risk</button></h4>
          <h4>After you assess your risks, help your customers identify theirs.</h4>
          <h4><button mat-raised-button (click)="openUrl('https://docs.connectwise.com/ConnectWise_Identify/002/020')">Assess Customer Risk</button></h4>
        </div>
        <div style="padding: 50px;">
          <img src="assets/CW-Identify-Macbook-Flat-Mockup.png" width="400">
        </div>
      </div>
      <div style="display: flex; align-self: center;">
        <div class="selectable" style="display: flex; flex-direction: column; align-items: center; max-width: 300px; margin: 20px;" (click)="openUrl('https://docs.connectwise.com/ConnectWise_Identify/002/040?mt-learningpath=identify')">
          <img src="assets/icons/large/large_icon_navigate.svg" style="max-width: 200px; padding:0 20px 10px 20px">
          <h2>Navigating Identify</h2>
          <span style="text-align: center">New to Identify? Follow this guide to get started.</span>
        </div>
        <div class="selectable" style="display: flex; flex-direction: column; align-items: center; max-width: 300px; margin: 20px;" (click)="openUrl('https://docs.connectwise.com/ConnectWise_Identify/002/050/020')">
          <img src="assets/icons/large/large_icon_customize.svg" style="max-width: 200px; padding:0 20px 10px 20px">
          <h2>Customize Identify</h2>
          <span style="text-align: center">Customize your assessment reports with your company branding.</span>
        </div>
        <div class="selectable" style="display: flex; flex-direction: column; align-items: center; max-width: 300px; margin: 20px;" (click)="openUrl('https://www.youtube.com/watch?v=9QIFffbIJT8')">
          <img src="assets/icons/large/large_icon_nist.svg" style="max-width: 200px; padding:0 20px 10px 20px">
          <h2 style="text-align: center">What is NIST?</h2>
          <span style="text-align: center">Watch this video to learn more about the NIST Cybersecurity Framework.</span>
        </div>
      </div>
      <div style="display: flex; justify-content: center; padding-bottom: 10px;">
        <button mat-raised-button color="primary" (click)="onEvent({state:'CLOSECLICKED'})">Close</button>
      </div>
      <div style="display: flex; justify-content: center; padding-bottom: 20px;">
        <mat-checkbox [(ngModel)]="openSplashScreen" (ngModelChange)="setSplashPreference()" class="mat-caption">Open Welcome Screen at Login</mat-checkbox>
      </div>
    </div>
  </div>
</div>